import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import UseTranslationHook from "../../hooks/UseTranslationHook";
import { ICTextInput } from "../../core-component/form";
import { eyeIcon, visibilityEyeIcon } from "../../assets/icons/SvgIconList";
import { ICButton } from "../../core-component/ui";
import {
  initialValuesChangePass,
  submitChangePassword,
  validationSchemaChangePassWord,
} from "./ChangePasswordController";

const ChangePassword = () => {
  const { t } = UseTranslationHook();
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const navigation = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const validationSchema = validationSchemaChangePassWord(t);
  const formikInitialValues = initialValuesChangePass;
  const formik = useFormik({
    initialValues: formikInitialValues,
    enableReinitialize: true,
    validationSchema,
    onSubmit: async (values) => {
      formik.setSubmitting(true);
      await submitChangePassword(values, navigation);
      formik.setSubmitting(false);
    },
  });

  return (
    <div className="flex items-center justify-center">
      <div className="w-full max-w-96">
        <p className="font-bold text-3xl mt-4 text-center">
          {t("change_password")}
        </p>
        <p className="text-muted text-sm text-center mt-2">
          {t("strong_password_instructions")}
        </p>
        <form className="rounded pt-8" onSubmit={formik.handleSubmit}>
          <div className="mb-4">
            <ICTextInput
              required
              type={showOldPassword ? "text" : "password"}
              trailing={
                showOldPassword ? (
                  <div
                    className="size-5"
                    onClick={() => {
                      setShowOldPassword(!showOldPassword);
                    }}
                  >
                    {eyeIcon}
                  </div>
                ) : (
                  <div
                    className="size-5"
                    onClick={() => {
                      setShowOldPassword(!showOldPassword);
                    }}
                  >
                    {visibilityEyeIcon}
                  </div>
                )
              }
              containerClassName="p-3"
              label={t("old_password")}
              name="old_password"
              value={formik.values.old_password}
              autoFocus
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              errorMessage={
                formik.touched.old_password &&
                formik.errors.old_password &&
                formik.errors.old_password
              }
            />
          </div>
          <div className="mb-4">
            <ICTextInput
              required
              type={showNewPassword ? "text" : "password"}
              trailing={
                showNewPassword ? (
                  <div
                    className="size-5"
                    onClick={() => {
                      setShowNewPassword(!showNewPassword);
                    }}
                  >
                    {eyeIcon}
                  </div>
                ) : (
                  <div
                    className="size-5"
                    onClick={() => {
                      setShowNewPassword(!showNewPassword);
                    }}
                  >
                    {visibilityEyeIcon}
                  </div>
                )
              }
              containerClassName="p-3"
              label={t("new_password")}
              name="new_password"
              value={formik.values.new_password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              errorMessage={
                formik.touched.new_password &&
                formik.errors.new_password &&
                formik.errors.new_password
              }
            />
          </div>
          <div className="mb-2">
            <ICTextInput
              required
              containerClassName="p-3"
              type={showPassword ? "text" : "password"}
              label={t("confirm_password")}
              trailing={
                showPassword ? (
                  <div className="size-5" onClick={togglePasswordVisibility}>
                    {eyeIcon}
                  </div>
                ) : (
                  <div className="size-5" onClick={togglePasswordVisibility}>
                    {visibilityEyeIcon}
                  </div>
                )
              }
              name="confirm_password"
              value={formik.values.confirm_password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              errorMessage={
                formik.touched.confirm_password &&
                formik.errors.confirm_password &&
                formik.errors.confirm_password
              }
            />
          </div>
          <div className="items-center justify-center mt-6">
            <ICButton
              className="w-full"
              type="submit"
              children={t("change_password")}
              loading={formik.isSubmitting}
            />
          </div>
        </form>
      </div>
    </div>
  );
};
export default ChangePassword;
